module.exports = __webpack_public_path__ + "static/amit-8dd9734f07b55b4353f3b197f7c31456.svg";